import './_global/_helpers/enforceHttps.js';
// import './_global/_helpers/updateContent.js';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { history, configureStore } from './_global/_helpers';
import App from './App';

// service woeker
// import registerServiceWorker from './registerServiceWorker';
import registerLocalServiceWorker from './localServiceWorker';

//theme
// import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
// import { createMuiTheme } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
// import pink from '@material-ui/core/colors/pink';

//fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faShippingFast, faShip } from '@fortawesome/free-solid-svg-icons'
library.add(faShippingFast, faShip);

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

// const theme = createMuiTheme({
//   palette: {
//     type: 'light',
//     primary: { main: '#1e88e5', },
//     // secondary: pink,
//   },
//   typography: {
//     useNextVariants: true,
//     suppressDeprecationWarnings: true
//   },
// });

// const themeDark = createMuiTheme({
//   palette: {
//     type: 'dark',
//     primary: { main: '#1e88e5', },
//     // secondary: pink,
//   },
//   typography: {
//     useNextVariants: true,
//     suppressDeprecationWarnings: true
//   },
// });

ReactDOM.render(
  // <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>,
  // </ThemeProvider>,
  rootElement);

// if (process.env.NODE_ENV === 'production')
//   registerServiceWorker();
// else
  registerLocalServiceWorker();